import { useDataEngine } from "@dhis2/app-runtime";

export const CONFIG = {
  program: "RSANdetbnWC",
  trackedEntityType: "OaAbpIs1cV7",
  stages: {
    config: "RF0WnJmJczX",     
    weights: "zY4mj9a30tk",
    midYear: "mJ3mC8f2eMv", 
    endYear: "TiLy9LFPaNo",
    approvals: "zC1XdAhrAhr",
  },
  de: {
    competencyId: "hM7qEqQBciM",
    competencyCode: "KekX9kvB4b2",
    competencyDefinition: "n9DVY0rbIsl",

    weightValue: "NnO0P1bqPGw",
    ratingScore: "fPIRWdClNPe",
    ratingComment: "SVFdFerDLV1",

    approvalStatus: "iNiXoYwyNUL",     
    approvalRemark: "s7aNZvcg8pH",

    positionReference: "SlgO60cMK3F"
  },
};

export function useLeadershipServices() {
  const engine = useDataEngine();

  // --- CREATE Event ---
  const createEvent = async (eventData) => {
    const query = {
      resource: "events",
      type: "create",
      data: eventData,
    };
    return await engine.mutate(query);
  };

  // --- READ Events ---
  const getEvents = async ({ program, trackedEntityInstance, orgUnit }) => {
    const query = {
      events: {
        resource: "events",
        params: {
          program,
          trackedEntityInstance,
          orgUnit,
          fields: "*",
        },
      },
    };
    const result = await engine.query(query);
    return result.events;
  };

  // --- UPDATE Event ---
  const updateEvent = async (eventId, updatedData) => {
    const query = {
      resource: `events/${eventId}`,
      type: "update",
      data: updatedData,
    };
    return await engine.mutate(query);
  };

  // --- DELETE Event ---
  const deleteEvent = async (eventId) => {
    const query = {
      resource: `events/${eventId}`,
      type: "delete",
    };
    return await engine.mutate(query);
  };

  // --- Specific service functions ---
  const saveWeightForCompetency = async (teiId, orgUnitId, competency) => {
    return createEvent({
      program: CONFIG.program,
      programStage: CONFIG.stages.config,
      trackedEntityInstance: teiId,
      orgUnit: orgUnitId,
      eventDate: new Date().toISOString(),
      status: "COMPLETED",
      dataValues: [
        { 
          dataElement: CONFIG.dataElements[`${competency.name}Weight`], 
          value: competency.weight 
        },
      ]
    });
  };

  const saveMidYearForCompetency = async (teiId, orgUnitId, competency) => {
    return createEvent({
      program: CONFIG.program,
      programStage: CONFIG.stages.midYear,
      trackedEntityInstance: teiId,
      orgUnit: orgUnitId,
      eventDate: new Date().toISOString(),
      status: "COMPLETED",
      dataValues: [
        { 
          dataElement: CONFIG.dataElements[`${competency.name}MidScore`], 
          value: competency.ratings[0] 
        },
        { 
          dataElement: CONFIG.dataElements[`${competency.name}MidComment`], 
          value: competency.comments[0] 
        },
      ]
    });
  };

  const saveEndYearForCompetency = async (teiId, orgUnitId, competency) => {
    return createEvent({
      program: CONFIG.program,
      programStage: CONFIG.stages.endYear,
      trackedEntityInstance: teiId,
      orgUnit: orgUnitId,
      eventDate: new Date().toISOString(),
      status: "COMPLETED",
      dataValues: [
        { 
          dataElement: CONFIG.dataElements[`${competency.name}EndScore`], 
          value: competency.ratings[1] 
        },
        { 
          dataElement: CONFIG.dataElements[`${competency.name}EndComment`], 
          value: competency.comments[1] 
        },
      ]
    });
  };

  return {
    createEvent,
    getEvents,
    updateEvent,
    deleteEvent,
    saveWeightForCompetency,
    saveMidYearForCompetency,
    saveEndYearForCompetency,
    CONFIG
  };
}